// extracted by mini-css-extract-plugin
export default {"panel":"PropertiesPanel_panel__7sFiA","header":"PropertiesPanel_header__AyN34","empty":"PropertiesPanel_empty__HcxaB"};